import { request } from "./request"

export const familyApi = {
  sendInviteToFamily: (userId, familyId, phoneOrEmail) => {
    return request('POST', `/api/2/users/${userId}/families/${familyId}/invites`, { phone_or_email: phoneOrEmail })
  }
}

